import Homepage from "./pages/homepage/homepage.component"
import Tutoring2 from "./pages/tutoring2/tutoring2.component"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import "./assets/fonts/font-style.scss"

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Homepage} />
        {/* <Route exact path="/tutoring" component={Tutoring2} /> */}
      </Switch>
    </BrowserRouter>
  )
}

export default App
